/** @format */

import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../app/hooks";
import AddCard from "./addCard/addCard";
import AddLesson from "./addLesson";
import AddActivity from "./addActivity";
import {
  selectAction,
  selectShowModal,
  setShowModal,
} from "./contentEditorSlice";
import "./contentEditor.scss";
import { UserResource } from "../resources/types";
import { useTranslation } from "react-i18next";

type Props = {
  resource: UserResource;
  dev?: boolean;
};

const ContentEditor: React.FC<Props> = ({ resource, dev = false }) => {
  const showModal = useAppSelector(selectShowModal());
  const action = useAppSelector(selectAction());
  const dispatch = useDispatch();
  const { t: _ } = useTranslation();

  // Load content based on action provided
  const loadContent = () => {
    switch (action) {
      case "lesson":
        return <AddLesson resource={resource} dev={dev} />;
      case "card":
        return <AddCard resource={resource} dev={dev} />;
      case "activity":
        return <AddActivity resource={resource} dev={dev} />;
      default:
        return <div>{_("Blank Content")}</div>;
    }
  };

  return showModal ? (
    <Modal
      fullscreen="sm-down"
      scrollable
      dialogClassName="content-editor-modal"
      show={showModal}
      onHide={() => dispatch(setShowModal(false))}
      centered
      enforceFocus={false}
    >
      {loadContent()}
    </Modal>
  ) : (
    <></>
  );
};

export default ContentEditor;
